
module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11"},"content":"<path d=\"M5.4 0C2.4 0 0 2.4 0 5.4s2.4 5.4 5.4 5.4 5.4-2.4 5.4-5.4S8.4 0 5.4 0zm3 6.8H4.7V1.7h.7L6 5.4l2.4.6v.8z\"></path>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
